// extracted by mini-css-extract-plugin
export var wrapper = "w_b";
export var bg = "w_bZ";
export var dots = "w_3";
export var transformMove = "w_b0";
export var circle = "w_b1";
export var transformRotate = "w_b2";
export var bubble = "w_b3";
export var transformScale = "w_b4";